var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.pageContainer},[_c('router-view'),_c('portal-target',{attrs:{"name":"modal"}}),(_vm.isViewChatWidget)?_c('ChatWidget'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }